// import { InputSelect } from "#common/componentes/Inputs"
import { MasterDialog } from "#common/Dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { jobProfileResponsibilityPost } from "#job-profile/services/api"
import { Box, Button, Divider } from "@mui/material"
import TextField from "@mui/material/TextField"
import { useCallback, useMemo, useState } from "react"
import { toast } from "react-toastify"
import JobProfileResponsibilitiesTable from "./JobProfileResponsibilitiesTable"

const responsibilitiesDefault = {
	name: "",
}

export default function JobProfileResponsibilitiesForm({ value, setValue }) {
	return (
		<TextField
			label="Descripción"
			value={value.name}
			onChange={(e) => setValue({ ...value, name: e.target.value })}
			fullWidth
			multiline
			rows={2}
		/>
	)
}

export const jobProfileResponsibilityFormValidate = (
	responsibility,
	responsibilities = []
) => {
	if (!responsibility.name) {
		toast.error("El descripción es requerido", { toastId: "invalidResponsibilityName" })
		return
	}
	if (responsibilities.filter((item) => item.name === responsibility.name).length > 0) {
		toast.error("La descripción ya existe", { toastId: "invalidResponsibilityName" })
		return
	}
	return true
}

export const JobProfileResponsibilitiesFormDialog = ({
	open,
	setOpen,
	profileId,
	refresh,
}) => {
	const [responsibilities, setResponsibilities] = useState(responsibilitiesDefault)
	const [disabled, setDisabled] = useState(false)
	const success = () => {
		setOpen(false)
		setResponsibilities(responsibilitiesDefault)
		refresh()
	}

	const end = () => {
		setDisabled(false)
	}

	const { fetch } = useApiSend(jobProfileResponsibilityPost, { success, end })

	const handleSend = useCallback(() => {
		if (!jobProfileResponsibilityFormValidate(responsibilities)) return
		setDisabled(true)
		fetch(profileId, responsibilities)
	}, [fetch, profileId, responsibilities])

	const handleClose = useCallback(() => {
		setOpen(false)
		setResponsibilities(responsibilitiesDefault)
	}, [setOpen])

	const buttons = useMemo(
		() => [
			{
				label: "Cancelar",
				onClick: handleClose,
				disabled,
			},
			{
				label: "Agregar",
				onClick: handleSend,
				disabled,
			},
		],
		[disabled, handleClose, handleSend]
	)

	return (
		<MasterDialog
			{...{
				open,
				setOpen,
				title: "Agregar responsabilidades | tareas",
				buttons,
				maxWidth: "md",
				closeDialog: handleClose,
			}}
		>
			<JobProfileResponsibilitiesForm
				value={responsibilities}
				setValue={setResponsibilities}
			/>
		</MasterDialog>
	)
}

export const JobProfileResponsibilitiesFormList = ({ value, setValue }) => {
	const [responsibility, setResponsibility] = useState({})

	const handleSave = () => {
		if (!jobProfileResponsibilityFormValidate(responsibility, value)) return

		setValue((old) => [...old, responsibility])
		setResponsibility(responsibilitiesDefault)
	}
	const handleDelete = (datum) => {
		setValue(value.filter((item) => item.name !== datum.name))
	}

	return (
		<Box display={"flex"} flexDirection={"column"} gap={2} alignItems={"center"}>
			<JobProfileResponsibilitiesForm
				value={responsibility}
				setValue={setResponsibility}
			/>
			<Button onClick={handleSave}>Agregar</Button>
			<Divider sx={{ width: "100%" }} />
			<JobProfileResponsibilitiesTable data={value || []} onDelete={handleDelete} />
		</Box>
	)
}
